// eslint-disable-next-line import/prefer-default-export
export const PALETTE_TAGS = [
  '#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00',
  '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF',
  '#333333', '#808080', '#CCCCCC', '#D33115', '#E27300', '#FCC400',
  '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF',
  '#000001', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00',
  '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E',
];

export const PALETTE_TYPE_OT = [
  '#999999', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00',
  '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#808080', '#CCCCCC',
  '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5',
  '#FA28FF', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900',
];

/*
Le noir est en code couleur #000001 car le composant
colorPicker choisi par default la couleur #000000, ce que nous ne
voulons pas pour les tags car ils doivent pouvoir être nullable
*/
